import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from './reducers'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['config', 'unrestricted'],
}

const loggerMiddleware = createLogger({ predicate: () => false })
const persistedReducer = persistReducer(persistConfig, rootReducer)

function configureStore (initialState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const enhancer = composeEnhancers(applyMiddleware(thunk, loggerMiddleware))

  return createStore(persistedReducer, initialState, enhancer)
}

const initialState = {}

export const store = configureStore(initialState)
export const persistor = persistStore(store)
